import React, { useState, useEffect } from "react";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../_metronic/_helpers";
import {
	Button,
	makeStyles,
	TableFooter,
	TableCell,
	TableRow,
	CircularProgress,
} from "@material-ui/core";
import { Pagination } from "react-bootstrap";
import { Dropdown } from "react-bootstrap";
import {
	DropdownCustomToggler,
	DropdownMenu4,
} from "../../_metronic/_partials/dropdowns";
import { ProgressBar, Modal, OverlayTrigger, Popover } from "react-bootstrap";
import { Link } from "react-router-dom";
import Moment from "moment";
import {
	getBotList,
	updateBotStatus,
	deleteBotStatus,
	getMyLicenseList,
	insertBot,
	updateBot,
	dupleCheckBotId,
} from "../modules/api";
import MUIDataTable from "mui-datatables";
import {
	validationEmail,
	validationPassword,
	validationPhoneNumber,
	validationBotId,
} from "../utils/validation";
import { isInteger } from "formik";

export function BotManage() {
	const [isShow, setIsShow] = useState(false);
	const [isShowBot, setIsShowBot] = useState(false);
	const [isUptShow, setIsUptShow] = useState(false);
	const [isShowLicense, setIsShowLicense] = useState(false);
	const [botList, setBotList] = useState([]);
	const [licenseList, setLicenseList] = useState([]);
	const [selectBot, setSelectBot] = useState();
	const [selectBotStatus, setSelectBotStatus] = useState();
	const [listLoading, setListLoading] = useState(false);
	const [validPassword, setValidPassword] = useState(false);
	const [password, setPassword] = useState();
	const [validEmailId, setValidEmailId] = useState(false);
	const [dupleEmailId, setDupleEmailId] = useState(false);
	const [emailId, setEmailId] = useState();
	const [confirmPass, setConfirmPass] = useState();
	const [validConfirmPass, setValidConfirmPass] = useState(false);
	const [licenseNo, setLicenseNo] = useState();
	const [validLicenseNo, setValidLicenseNo] = useState(false);
	const [selectBotName, setSelectBotName] = useState();
	const [selectLicense, setSelectLicense] = useState();
	const [selectBotList, setSelectBotList] = useState([]);
	const [licenseName, setLicenseName] = useState();
	const [choiceLicenseName, setChoiceLicenseName] = useState();
	const [choiceLicenseNo, setChoiceLicenseNo] = useState();
	const [choiceIndex, setChoiceIndex] = useState();
	const [memo, setMemo] = useState();
	const [botId, setBotId] = useState();
	const [expireList, setExpireList] = useState(0);
	const [isPwUpdate, setIsPwUpdate] = useState(false);

	const useStyles = makeStyles((theme) => ({
		container: {
			display: "flex",
			flexWrap: "wrap",
		},
		textField: {
			marginLeft: theme.spacing(1),
			marginRight: theme.spacing(1),
			width: 200,
		},
		centeredHeader: {
			"& span": {
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
				fontSize: 15,
				fontWeight: "bold",
			},
		},
	}));

	const classes = useStyles();

	const fetchData = async () => {
		try {
			setSelectBot("");
			setSelectBotStatus("");
			setIsPwUpdate(false);
			setValidPassword(false);
			setValidConfirmPass(false);

			const result = await getBotList();
			const licenseResult = await getMyLicenseList();
			console.log("manageBot", result);
			console.log("licenseResult", licenseResult);
			setLicenseList(licenseResult.data);

			let count = 0;
			licenseResult.data.map((data, index) => {
				if (data.remainDays <= 0) {
					count = count + 1;
				}
			});
			setExpireList(count);

			const nowDate = Moment(new Date()).format("YYYY-MM-DD");

			let list = [];
			result.data.map((data, index) => {
				if (data.deletedAt === null) {
					var obj = new Object();
					obj.idx = index;
					obj.no = data.no;
					obj.botId = data.loginId;
					obj.botStatus =
						Moment(data.endAt).format("YYYY-MM-DD") < nowDate
							? 3
							: data.accountStatus;
					obj.licenseNo = data.licenseHistoryNumber;
					obj.endAt = Moment(data.endAt).format("YYYY-MM-DD");
					obj.createdAt = data.createdAt
						? Moment(data.createdAt).format("YYYY-MM-DD HH:mm:ss")
						: "-";
					obj.macAddress = data.macId;

					for (let i = 0; i < licenseResult.data.length; i++) {
						for (let j = 0; j < licenseResult.data[i].botList.length; j++) {
							if (data.no === licenseResult.data[i].botList[j].no) {
								obj.licenseId = licenseResult.data[i].no;

								if (licenseResult.data[i].status == "N") {
									obj.botStatus = 1;
								}
							}
						}
					}
					obj.memo = data.memo;
					list.push(obj);
				}
			});

			setBotList(list);
		} catch (e) {
			console.log(e);
			// Handle error
		}
	};

	useEffect(() => {
		setListLoading(true);
		setTimeout(async () => {
			fetchData();
			setListLoading(false);
		}, 1000);
	}, []);

	const toggleShow = () => {
		setIsShow(!isShow);
	};

	const toggleLicense = () => {
		setIsShowLicense(!isShowLicense);
	};

	const toggleShowBot = () => {
		setIsShowBot(!isShowBot);
	};

	const toggleUptShow = () => {
		setIsUptShow(!isUptShow);
	};

	const isPasswordUpdate = () => {
		setIsPwUpdate(!isPwUpdate);
	};

	const licenseUpdate = () => {
		if (choiceLicenseName !== "") {
			setLicenseName(choiceLicenseName);
        }
    }

	const columns = [
		{
			name: "botId",
			label: "Bot ID",
			options: {
				filter: true,
				sort: true,
				setCellProps: () => ({ style: { textAlign: "center" } }),
				setCellHeaderProps: () => ({
					className: classes.centeredHeader,
				}),
			},
		},
		{
			name: "botStatus",
			label: "Bot 상태",
			options: {
				filter: true,
				sort: true,
				setCellProps: () => ({ style: { textAlign: "center"} }),
				setCellHeaderProps: () => ({
					className: classes.centeredHeader,
					style: { width: "120px" },
				}),
				customBodyRender: (value, meta) => {
					let textLabel;
					let textColor;

					if (value === 2) {
						textLabel = "사용";
						textColor = "label-success";
					} else if (value === 1) {
						textLabel = "사용중지";
						textColor = "label-primary";
					} else if (value === 3) {
						textLabel = "기간만료";
						textColor = "label-secondary";
					}
					return (
						<div>
							<span className={"label label-xl label-inline " + textColor}>
								{textLabel}
							</span>
						</div>
					);
				},
			},
		},
		{
			name: "licenseNo",
			label: "라이선스",
			options: {
				filter: true,
				sort: true,
				setCellProps: () => ({ style: { textAlign: "center"} }),
				setCellHeaderProps: () => ({
					className: classes.centeredHeader,
					style: { width: "250px" },
				}),
			},
		},
		{
			name: "endAt",
			label: "만료일",
			options: {
				filter: true,
				sort: true,
				setCellProps: () => ({ style: { textAlign: "center" } }),
				setCellHeaderProps: () => ({
					className: classes.centeredHeader,
				}),
			},
		},
		{
			name: "macAddress",
			label: "PC MAC주소",
			options: {
				filter: true,
				sort: true,
				setCellProps: () => ({ style: { textAlign: "center" } }),
				setCellHeaderProps: () => ({
					className: classes.centeredHeader,
				}),
			},
		},
		{
			name: "createdAt",
			label: "등록일시",
			options: {
				filter: true,
				sort: true,
				setCellProps: () => ({ style: { textAlign: "center" } }),
				setCellHeaderProps: () => ({
					className: classes.centeredHeader,
				}),
			},
		},
		{
			name: "no",
			options: {
				filter: false,
				sort: false,
				display: false,
				viewColumns: false,
			},
		},
		{
			name: "licenseId",
			options: {
				filter: false,
				sort: false,
				display: false,
				viewColumns: false,
			},
		},
		{
			name: "memo",
			options: {
				filter: false,
				sort: false,
				display: false,
				viewColumns: false,
			},
		},
		{
			name: "action",
			label: "작업",
			options: {
				filter: false,
				sort: false,
				setCellProps: () => ({
					style: { textAlign: "center" },
				}),
				setCellHeaderProps: () => ({
					style: { textAlign: "center", fontSize: 15, fontWeight: "bold", width : "280px"},
				}),
				customBodyRender: (value, meta) => {
					// console.log("metameta", meta);
					// if (userNo.toString() === meta.rowData[6].toString()) {
					return (
						<div>
							<Button
								className={`btn btn-xs font-weight-bolder btn-primary font-size-sm mr-2`}
								onClick={() => {
									delSingleBot(meta.rowData[6]);
								}}
							>
								삭제
              </Button>
							<Button
								className={`btn btn-xs font-weight-bolder font-size-sm mr-2`}
								style={{ background: "lightgray" }}
								type="button"
								onClick={() => {
									singleUpdate(meta.rowData[6], meta.rowData[1]);
								}}
							>
								{meta.rowData[1] === 2 ? "사용중지" : "사용"}
							</Button>
							<Button
								className={`btn btn-xs font-weight-bolder font-size-sm mr-2`}
								style={{ background: "lightgray" }}
								type="button"
								onClick={() => {
									setEmailId(meta.rowData[0]);
									setLicenseName(meta.rowData[2]);
									setMemo(meta.rowData[8]);
									setIsUptShow(true);
									setChoiceLicenseNo(meta.rowData[7]);
									setBotId(meta.rowData[6]);
								}}
							>
								수정
              </Button>
						</div>
						
					);
				},
			},
		},
	];

	const options = {
		print: false,
		download: false,
		filter: false,
		viewColumns: false,
		rowsPerPage: 15,
		rowsPerPageOptions: [],
		selectToolbarPlacement: "none",
		selectableRows: true,

		// selectableRowsOnClick: true,

		// onRowClick: (rowData, rowState) => {
		// 	console.log("rowData", rowData);
		// 	console.log("rowState", rowState);
		// 	// editNotice(rowData[5], "dtl");
		// 	// setNoticeNo(rowData[5]);
		// },
		onCellClick: (cellData, cellMeta) => {
			console.log("cellData", cellData);
			// if (cellMeta.colIndex !== 7) {
			// 	viewNotice();
			// }
			// editNotice(, "dtl");
		},
		onRowSelectionChange: (
			currentRowsSelected,
			allRowsSelected,
			rowsSelected
		) => {
			let temp = [];
			let tempStatus = [];
			let indexes = [];
			rowsSelected.forEach((row) => {
				indexes.push(row);
			});
			botList.map((data, index) => {
				if (indexes.includes(data.idx)) {
					temp.push(data.no);
					tempStatus.push(data.botStatus);
				}
			});
			console.log("indexes", indexes);
			console.log("temp", temp.toString());
			console.log("tempStatus", tempStatus.toString());
			setSelectBot(temp.toString());
			setSelectBotStatus(tempStatus.toString());
		},
		textLabels: {
			body: {
				noMatch: listLoading ? (
					<CircularProgress size={25} color={"inherit"} />
				) : botList && botList.length > 0 ? (
					""
				) : (
					"검색 결과가 없습니다."
				),
			},
		},
	};

	const singleUpdate = async (botNo, status) => {
		if (status == 3) {
			alert("해당 Bot에 라이선스 사용기간이 만료 되었으므로, 상태를 변경 할 수 없습니다.");
			return false;
		}

		const param = {
			botNoList: botNo,
			status: status === 1 ? "Y" : "N",
		};

		const res = await updateBotStatus(param);
		if (res.result) {
			alert("정상적으로 수정되었습니다.");
			fetchData();
		} else {
			alert("정상적으로 수정되지 않았습니다.");
			return false;
		}
	};

	const doUse = async () => {
		console.log("selectBot", selectBot);
		console.log("selectBotStatus", selectBotStatus);
		if (selectBot === undefined || selectBot === "") {
			alert("1개 이상의 Bot을 선택해 주세요.");
			return false;
		}

		if (selectBotStatus.includes("3")) {
			alert("선택한 Bot 중 기간만료 상태의 Bot이 존재하며, 해당 Bot은 상태가 변경 되지 않습니다.");
		}

		const param = {
			botNoList: selectBot,
			status: "Y",
		};

		const res = await updateBotStatus(param);
		if (res.result) {
			alert("정상적으로 수정되었습니다.");
			fetchData();
		} else {
			alert("정상적으로 수정되지 않았습니다.");
			return false;
		}
	};

	const doNoUse = async () => {
		if (selectBot === undefined || selectBot === "") {
			alert("1개 이상의 Bot을 선택해 주세요.");
			return false;
		}

		if (selectBotStatus.includes("3")) {
			alert("선택한 Bot 중 기간만료 상태의 Bot이 존재하며, 해당 Bot은 상태가 변경 되지 않습니다.");
		}

		const param = {
			botNoList: selectBot,
			status: "N",
		};

		const res = await updateBotStatus(param);
		if (res.result) {
			alert("정상적으로 수정되었습니다.");
			fetchData();
		} else {
			alert("정상적으로 수정되지 않았습니다.");
			return false;
		}
	};

	const delSingleBot = async (value) => {
		const param = {
			botNoList: value,
		};
		const res = await deleteBotStatus(param);
		if (res.result) {
			alert("정상적으로 삭제되었습니다.");
			fetchData();
		} else {
			alert("정상적으로 삭제되지 않았습니다.");
			return false;
		}
	};

	const delBot = async () => {
		if (selectBot == "" || selectBot === undefined) {
			alert("1개 이상의 Bot을 선택해 주세요.");
			return false;
		}

		const param = {
			botNoList: selectBot,
		};
		const res = await deleteBotStatus(param);
		console.log("deleteBotStatus", res);
		if (res.result) {
			alert("정상적으로 삭제되었습니다.");
			fetchData();
		} else {
			alert("정상적으로 삭제되지 않았습니다.");
			return false;
		}
	};

	const comparePass = (value) => {
		if (password !== value) {
			setValidConfirmPass(true);
			return false;
		} else {
			setValidConfirmPass(false);
		}
	};

	const addBot = async () => {
		//ID중복체크 로직 추가
		if (emailId !== undefined) {
			if (!validationBotId(emailId.trim())) {
				setValidEmailId(true);
				return false;
			} else {
				setValidEmailId(false);
			}
		} else {
			setValidEmailId(true);
			return false;
		}

		const duple = await dupleCheckBotId(emailId);
		if (!duple.result) {
			setDupleEmailId(true);
			return false;
		} else {
			setDupleEmailId(false);
		}

		if (password !== undefined) {
			if (!validationPassword(password.trim())) {
				setValidPassword(true);
				return false;
			} else {
				setValidPassword(false);
			}
		} else {
			setValidPassword(true);
			return false;
		}

		if (confirmPass !== undefined) {
			if (password !== confirmPass) {
				setValidConfirmPass(true);
				return false;
			} else {
				setValidConfirmPass(false);
			}
		} else {
			setValidConfirmPass(true);
			return false;
		}
		if (licenseNo === undefined) {
			setValidLicenseNo(true);
			// return false;
		} else {
			setValidLicenseNo(false);
		}
		console.log("choiceLicenseNo", choiceLicenseNo);
		const param = {
			licenseNo: choiceLicenseNo,
			loginId: emailId,
			password: password,
			memo: memo,
		};

		const res = await insertBot(param);
		console.log("resres", res);
		toggleShow();
		setEmailId("");
		setPassword("");
		setConfirmPass("");
		setChoiceLicenseName("");
		setMemo("");
		if (res.result) {
			alert("정상적으로 등록되었습니다.");
			fetchData();
		} else {
			alert("정상적으로 등록되지 않았습니다.");
			fetchData();
		}
	};

	const uptBot = async () => {
		console.log("1");
		
		//비밀번호 변경을 눌렀다면
		if (isPwUpdate) {
			if (password !== undefined) {
				if (!validationPassword(password.trim())) {
					setValidPassword(true);
					return false;
				} else {
					setValidPassword(false);
				}
			} else {
				setValidPassword(true);
				return false;
			}

			if (confirmPass !== undefined) {
				if (password !== confirmPass) {
					setValidConfirmPass(true);
					return false;
				} else {
					setValidConfirmPass(false);
				}
			} else {
				setValidConfirmPass(true);
				return false;
			}
        }
		console.log("4");
		if (licenseNo === undefined) {
			setValidLicenseNo(true);
			// return false;
		} else {
			setValidLicenseNo(false);
		}
		console.log("choiceLicenseNo", choiceLicenseNo);
		const param = {
			licenseNo: choiceLicenseNo,
			loginId: emailId,
			password: password,
			memo: memo,
		};
		console.log("5");
		const res = await updateBot(botId, param);
		console.log("resres", res);
		toggleUptShow();
		if (res.result) {
			alert("정상적으로 수정되었습니다.");
			fetchData();
		} else {
			alert("정상적으로 수장되지 않았습니다.");
			fetchData();
		}
	};

	const styles = {
		border: "solid 2px #ff6f5e",
		padding: 10,
		borderRadius: 10,
		backgroundColor: "rgb(252, 230, 227)",
	};

	const noStyles = {
		border: "solid 2px #fff",
		padding: 10,
		borderRadius: 10,
		backgroundColor: "rgb(255,255,255)",
	};
	const license = licenseList.map((data, index) => {
		let startDate = new Date(data.startAt);
		let nowDate = new Date();
		let realBotAmount = 0;
		for (let i = 0; i < data.botList.length; i++) {
			if (data.botList[i].deletedAt === null) {
				realBotAmount = realBotAmount + 1;
			}
		}

		let useDays = Moment(data.endAt).diff(data.startAt, "days");
		let todayDiff = Moment(new Date()).diff(data.startAt, "days");
		let usedDays;
		let expireText;
		if (todayDiff < 0) {
			usedDays = 0;
		} else if (todayDiff > useDays) {
			usedDays = useDays;
			expireText = "기간만료";
		} else {
			usedDays = todayDiff;
		}

		let useRate = Math.floor(
			isNaN((usedDays / useDays) * 100) ? 0 : (usedDays / useDays) * 100
		);

		console.log("todayDiff", todayDiff);

		return (
			<li
				className="mb-10"
				style={choiceIndex === index ? styles : noStyles}
				onClick={
					// () => console.log(realBotAmount, data.botAmount)
					realBotAmount >= data.botAmount || expireText == "기간만료"
						? ""
						: () => {
								setChoiceLicenseName(data.licenseNumber);
								setChoiceLicenseNo(data.no);
								setChoiceIndex(index);
						  }
				}
			>
				<div
					className="d-flex align-items-center justify-content-between"
					style={{ marginRight: 100 }}
				>
					<p className="mb-0 license-number">
						{data.licenseNumber} ({data.botAmount}bot for {useDays}days)
					</p>
					<div
						className="font-weight-bold"
						style={{ textDecoration: "underline" }}
						onClick={() => {
							// if (realBotAmount >= data.botAmount) {
							//   alert("사용 개수를 초과 하였습니다.");
							//   return false;
							// }
							toggleShowBot();
							setSelectBotList(data.botList);
							setSelectBotName(
								realBotAmount + "Bot /" + data.botAmount + "Bot"
							);
							const useDays = Moment(data.endAt).diff(data.startAt, "days");
							setSelectLicense(
								data.licenseNumber +
									" (" +
									data.botAmount +
									"bot for " +
									useDays +
									"days)"
							);
						}}
					>
						{realBotAmount}Bot / {data.botAmount}Bot
					</div>
				</div>
				<small className="mb-1 d-flex text-muted">
					<span style={{ paddingTop: "2px", marginRight: "10px" }}>
						{Moment(data.startAt).format("YY-MM-DD")} –{" "}
						{Moment(data.endAt).format("YY-MM-DD")}
					</span>
					<span style={{ paddingTop: "2px" }}> {expireText}</span>
				</small>
				<div className="progress-wrap d-flex align-items-center justify-content-between">
					<div className="w-100">
						<ProgressBar now={useRate} />
					</div>
					<p className="mb-0 ml-2 days text-right">
						{usedDays} / {useDays}days
					</p>
				</div>
			</li>
		);
	});

	return (
		<div id="pageid31">
			{/* Bot 추가 Modal 시작 */}
			<Modal
				show={isShow}
				// aria-labelledby="example-modal-sizes-title-lg"
			>
				<Modal.Header closeButton>
					<Modal.Title id="example-modal-sizes-title-lg">Bot 추가</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<p>Bot ID</p>
					<div className="form-group fv-plugins-icon-container">
						<input
							placeholder="Bot ID"
							type="email"
							className={`form-control form-control-solid h-auto py-5 px-6 `}
							name="email"
							maxLength="30"
							value={emailId}
							onChange={(e) => { setEmailId(e.target.value); setValidEmailId(false); setDupleEmailId(false);}}
						/>
						{validEmailId && (
							<div className="fv-plugins-message-container">
								<div className="fv-help-block text-danger mt-1 font-size-sm">
									Bot ID는 영문 또는 영문과 숫자 조합입니다.
								</div>
							</div>
						)}
						{dupleEmailId && (
							<div className="fv-plugins-message-container">
								<div className="fv-help-block text-danger mt-1 font-size-sm">
									동일한 Bot ID가 존재합니다.
								</div>
							</div>
						)}
					</div>
					<p>비밀번호</p>
					<div className="form-group fv-plugins-icon-container">
						<input
							placeholder="비밀번호(영어+숫자+특수문자8~20자)"
							type="password"
							className={`form-control form-control-solid h-auto py-5 px-6 `}
							name="password"
							maxLength="25"
							value={password}
							onChange={(e) => setPassword(e.target.value)}
						/>
						{validPassword ? (
							<div className="fv-plugins-message-container">
								<div className="fv-help-block text-danger mt-1 font-size-sm">
									패스워드는 8 ~ 20자리 이며 알파벳, 특수문자, 숫자를 포함해야
									합니다.
								</div>
							</div>
						) : null}
					</div>
					<p>비밀번호 확인</p>
					<div className="form-group fv-plugins-icon-container">
						<input
							placeholder="비밀번호 확인"
							type="password"
							className={`form-control form-control-solid h-auto py-5 px-6`}
							name="changepassword"
							maxLength="25"
							value={confirmPass}
							onChange={(e) => {
								setConfirmPass(e.target.value);
								comparePass(e.target.value);
							}}
						/>
						{validConfirmPass ? (
							<div className="fv-plugins-message-container">
								<div className="fv-help-block text-danger mt-1 font-size-sm">
									Password와 일치하지 않습니다.
								</div>
							</div>
						) : null}
					</div>
					<p>라이선스</p>
					<div className="form-group fv-plugins-icon-container">
						<div className="d-flex align-items-center justify-content-between">
							<input
								placeholder=""
								type="text"
								className={`form-control form-control-solid h-auto py-5 px-6 `}
								name="license"
								disabled
								value={choiceLicenseName}
								style={{ backgroundColor: "lightgrey", borderCcolor: "lightgrey" }}
							/>
							<Button
								className={`btn btn-primary font-weight-bold text-white ml-2`}
								onClick={() => {
									toggleLicense();
									// toggleShow();
								}}
							>
								라이선스 선택
							</Button>
						</div>
						{licenseNo ? (
							<div className="fv-plugins-message-container">
								<div className="fv-help-block text-danger mt-1 font-size-sm">
									라이센스를 선택해 주세요.
								</div>
							</div>
						) : null}
					</div>
					<p>메모</p>
					<div className="form-group fv-plugins-icon-container">
						<textarea
							className="modal-textarea"
							name="memo"
							value={memo}
							onChange={(e) => setMemo(e.target.value)}
						></textarea>
					</div>
				</Modal.Body>
				<Modal.Footer>
					<div>
						<button
							type="button"
							onClick={() => {
								toggleShow();
								setEmailId("");
								setPassword("");
								setConfirmPass("");
								setChoiceLicenseName("");
								setMemo("");
								setValidEmailId(false);
								setDupleEmailId(false);
							}}
							className="btn btn-light btn-elevate"
						>
							취소
						</button>
						<> </>
						<button
							type="button"
							onClick={addBot}
							className="btn btn-primary btn-elevate"
							disabled={
								!emailId || !password || !confirmPass || !choiceLicenseName
							}
						>
							확인
						</button>
					</div>
				</Modal.Footer>
			</Modal>
			{/* Bot 추가 Modal 끝 */}

			<Modal
				show={isUptShow}
				// aria-labelledby="example-modal-sizes-title-lg"
			>
				<Modal.Header closeButton>
					<Modal.Title id="example-modal-sizes-title-lg">Bot 수정</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<p>Bot ID</p>
					<div className="form-group fv-plugins-icon-container">
						<input
							placeholder="Bot ID"
							type="email"
							className={`form-control form-control-solid h-auto py-5 px-6 `}
							name="email"
							maxLength="30"
							value={emailId}
							style={{ backgroundColor: "lightgrey", borderCcolor: "lightgrey"}}
							readOnly
						/>
					</div>
					<div style={{ display: "inline-flex" }}>
						<p>비밀번호</p>
						<button class="btn btn-secondary" style={{
							height: "20px",
							width: "40px",
							padding: "0px 2px 2px 0px",
							fontSize: "11px",
							margin: "1px 0px 0px 3px"
						}}
							onClick={() => isPasswordUpdate()}
						>
							{isPwUpdate ? "취소" : "변경"}
						</button>
					</div>
					{isPwUpdate && 
						<div>
							<div className="form-group fv-plugins-icon-container">
								<input
									placeholder="비밀번호(영어+숫자+특수문자8~20자)"
									type="password"
									className={`form-control form-control-solid h-auto py-5 px-6 `}
									name="password"
									maxLength="25"
									value={password}
									onChange={(e) => setPassword(e.target.value)}
								/>
								{validPassword ? (
									<div className="fv-plugins-message-container">
										<div className="fv-help-block text-danger mt-1 font-size-sm">
											패스워드는 8 ~ 20자리 이며 알파벳, 특수문자, 숫자를 포함해야
											합니다.
								</div>
									</div>
								) : null}
							</div>
							<p>비밀번호 확인</p>
							<div className="form-group fv-plugins-icon-container">
							<input
								placeholder="비밀번호 확인"
								type="password"
								className={`form-control form-control-solid h-auto py-5 px-6`}
								name="changepassword"
								maxLength="25"
								value={confirmPass}
								onChange={(e) => { setConfirmPass(e.target.value); comparePass(e.target.value); }}
								/>
								{validConfirmPass ? (
									<div className="fv-plugins-message-container">
										<div className="fv-help-block text-danger mt-1 font-size-sm">
											Password와 일치하지 않습니다.
								</div>
									</div>
								) : null}
							</div>
						</div>
					}
					
					<p>라이선스</p>
					<div className="form-group fv-plugins-icon-container">
						<div className="d-flex align-items-center justify-content-between">
							<input
								placeholder=""
								type="text"
								className={`form-control form-control-solid h-auto py-5 px-6 `}
								name="license"
								disabled
								value={licenseName}
								style={{ backgroundColor: "lightgrey", borderCcolor: "lightgrey" }}
							/>
							<Button
								className={`btn btn-primary font-weight-bold text-white ml-2`}
								onClick={() => {
									toggleLicense();
									// toggleShow();
								}}
							>
								라이선스 선택
							</Button>
						</div>
						{licenseNo ? (
							<div className="fv-plugins-message-container">
								<div className="fv-help-block text-danger mt-1 font-size-sm">
									라이센스를 선택해 주세요.
								</div>
							</div>
						) : null}
					</div>
					<p>메모</p>
					<div className="form-group fv-plugins-icon-container">
						<textarea
							className="modal-textarea"
							name="memo"
							value={memo}
							onChange={(e) => setMemo(e.target.value)}
						></textarea>
					</div>
				</Modal.Body>
				<Modal.Footer>
					<div>
						<button
							type="button"
							onClick={() => {
								toggleUptShow();
								setEmailId("");
								setPassword("");
								setConfirmPass("");
								setChoiceLicenseName("");
								setMemo("");
								setIsPwUpdate(false);
								setValidPassword(false);
								setValidConfirmPass(false);
							}}
							className="btn btn-light btn-elevate"
						>
							취소
						</button>
						<> </>
						{isPwUpdate ? 
							<button
								type="button"
								onClick={uptBot}
								className="btn btn-primary btn-elevate"
								disabled={
									!emailId || !password || !confirmPass || !licenseName
								}
							>
								수정
							</button>

							:
							<button
								type="button"
								onClick={uptBot}
								className="btn btn-primary btn-elevate"
								disabled={
									!emailId || !licenseName
								}
							>
								수정
							</button>
                        }
						
					</div>
				</Modal.Footer>
			</Modal>

			{/* D4:라이선스 선택 클릭 시 모달 활성화 시작 */}
			<Modal
				show={isShowLicense}
				size="lg"
				// aria-labelledby="example-modal-sizes-title-lg"
			>
				<Modal.Header closeButton>
					<Modal.Title id="example-modal-sizes-title-lg">라이선스</Modal.Title>
				</Modal.Header>
				<Modal.Body className="px-5">
					<div className="text-right mb-10">
						<p>
							총 <b>{licenseList.length}개</b> 라이선스 중{" "}
							<b>{licenseList.length - expireList}개</b>가 활성화 중이며,{" "}
							<b>{expireList}개</b>가 만료 되었습니다
						</p>
					</div>
					<ul className="mb-15 pl-0 no-list-style pr-2">{license}</ul>
				</Modal.Body>
				<Modal.Footer>
					<div>
						<button
							type="button"
							onClick={() => {
								toggleLicense();
								setChoiceIndex("");
								setChoiceLicenseName("");
							}}
							className="btn btn-light btn-elevate"
						>
							취소
						</button>
						<> </>
						<button
							type="button"
							onClick={() => {
								toggleLicense();
								licenseUpdate();
								setChoiceIndex("");
							}}
							className="btn btn-primary btn-elevate"
						>
							확인
						</button>
					</div>
				</Modal.Footer>
			</Modal>
			{/* D4:라이선스 선택 클릭 시 모달 활성화 끝 */}

			{/* D9: 특정항목을 작성하지 않았을 시 시작 */}
			{/* <Modal show={isShow} onHide={toggleShow}>
        <Modal.Header closeButton>
          <Modal.Title id="example-modal-sizes-title-lg">
            Bot 추가 오류
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center">
          <p className="mb-0">xxx항목을 작성해 주세요.</p>
        </Modal.Body>
        <Modal.Footer>
          <div>
            <button
              type="button"
              onClick={toggleShow}
              className="btn btn-primary btn-elevate"
            >
              확인
            </button>
          </div>
        </Modal.Footer>
      </Modal> */}
			{/* D9: 특정항목을 작성하지 않았을 시 끝 */}
			{/* D1: Bot 개수 선택 시 라이선스 상세 모달 활성화 시작*/}
			<Modal show={isShowBot}>
				<Modal.Header closeButton>
					<Modal.Title id="example-modal-sizes-title-lg">Bot 확인</Modal.Title>
				</Modal.Header>
				<Modal.Body className="text-center">
					<div className="d-flex align-items-center justify-content-between mb-5">
						<p className="mb-0 license-number">{selectLicense}</p>
						<p className="mb-0 font-weight-bold">{selectBotName}</p>
					</div>
					<table>
						<thead>
							<tr>
								<th>Bot ID</th>
								<th>Bot 상태</th>
							</tr>
						</thead>
						<tbody>
							{selectBotList.length > 0 &&
								selectBotList.map((data, index) => {
									let textLabel;
									let textColor;

									if (data.accountStatus === 2) {
										textLabel = "사용";
										textColor = "label-success";
									} else if (data.accountStatus === 1) {
										textLabel = "사용중지";
										textColor = "label-primary";
									} else if (data.accountStatus === 3) {
										textLabel = "기간만료";
										textColor = "label-secondary";
									}
									return (
										<tr>
											<td>{data.loginId}</td>
											<td>
												<span
													className={"label label-xl label-inline " + textColor}
												>
													{textLabel}
												</span>
											</td>
										</tr>
									);
								})}
							{selectBotList.length === 0 && (
								<tr>
									<td colSpan="2">
										<span>등록된 Bot이 없습니다.</span>
									</td>
								</tr>
							)}
							{/* <tr>
								<td>Logan1</td>
								<td>
									<span className="label label-xl label-inline label-success">
										사용
									</span>
								</td>
							</tr>
							<tr>
								<td>Logan2</td>
								<td>
									<span className="label label-xl label-inline label-primary">
										사용중지
									</span>
								</td>
							</tr>
							<tr>
								<td>Logan3</td>
								<td>
									<span className="label label-xl label-inline label-secondary">
										기간만료
									</span>
								</td>
							</tr> */}
						</tbody>
					</table>
				</Modal.Body>
				<Modal.Footer>
					<div>
						<button
							type="button"
							onClick={toggleShowBot}
							className="btn btn-primary btn-elevate"
						>
							확인
						</button>
					</div>
				</Modal.Footer>
			</Modal>
			{/* D1: Bot 개수 선택 시 라이선스 상세 모달 활성화 끝 */}
			<div style={{ marginTop: 30 }}>
				<h3 className="card-label font-weight-bolder text-dark d-flex align-items-center mb-0">
					Bot 관리
				</h3>
			</div>
			<div className="top-row gutter-b d-flex align-items-center flex-column">
				<div
					className="d-flex align-items-center justify-content-end w-100"
					style={{ marginTop: 50 }}
				>
					<div className="mr-5 after">
						<Button
							className={`btn btn-info font-weight-bolder font-size-sm mr-2`}
							onClick={doUse}
						>
							사용
						</Button>
						<Button
							className={`btn btn-danger font-weight-bolder font-size-sm mr-2`}
							// style={{ border: "solid 1px #D1D3E0" }}
							onClick={doNoUse}
						>
							사용중지
						</Button>
					</div>
					<div style={{ marginLeft: 8 }}>
						<Button
							className={`btn btn-info font-weight-bolder font-size-sm mr-2`}
							onClick={toggleShow}
						>
							Bot 추가
						</Button>
						<Button
							className={`btn btn-danger font-weight-bolder font-size-sm mr-2`}
							// style={{ border: "solid 1px #D1D3E0" }}
							onClick={delBot}
						>
							Bot 삭제
						</Button>
					</div>
				</div>
			</div>
			<div className="gutter-b">
				<div className="table-responsive">
					<MUIDataTable
						// title={"Bot 관리"}
						data={botList}
						columns={columns}
						options={options}
					/>
				</div>
			</div>
		</div>
	);
}
export default BotManage;
